import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setDoesDiscountMatchesCart, setDoesThresholdExist, setGlobalDiscounDescription, setGlobalDiscountShippingType, setIsGlobalCartDiscountFree } from './application';
import { RootState } from '.';
import { onErrorHandler } from './handlers';
import { DiscountType } from '../enums/discountType';
import { CheckoutSteps } from '../enums/checkoutSteps';

declare const window: any;

export const discountCodeApi = createApi({
  reducerPath: 'discountCodeApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: window.Config?.LAMBDA_DISCOUNT ?? 'https://npr-discount-code.api.pens.com/',
    prepareHeaders: (headers) => {
      headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
      return headers
  }},
  ),
  tagTypes: ['getCartDiscounts','getDiscountByDiscountId'],
  endpoints: (builder) => ({
    getCartDiscounts: builder.query({
      query: ({cartId,locale}) => ({
        url: `v2/cartdiscounts/getMatchingDiscountForCart/${cartId}`,
        params: { locale: locale },
      }),
      async onQueryStarted(args, { dispatch, getState, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          // Set whether the threshold exists
          dispatch(setDoesThresholdExist(Boolean(data?.cartSubTotal)));

          if(data?.customLineItemTarget === CheckoutSteps.SHIPPING && data?.shippingType){
            dispatch(setGlobalDiscountShippingType(data.shippingType))
          }
          //Check whether the discount matches cart
          dispatch(setDoesDiscountMatchesCart(Boolean(data?.matchesCart)));

          const { discountValue } = data || {};
          const isFreeDiscount: boolean = discountValue?.type === DiscountType.RELATIVE && discountValue.permyriad === 10000;
          dispatch(setIsGlobalCartDiscountFree(isFreeDiscount));

    
          // Set global discount description and ID if present
          if (data?.description) {
            dispatch(setGlobalDiscounDescription(data.description));
          }
        }
        catch(error:any){
              console.log("Error: While matching discount for cart",error);
              if(error?.error?.status !== 404){
                dispatch(onErrorHandler({operation: 'get matching discount for cart', err: JSON.stringify(error), errMsg: 'Error: While matching discount for cart', api:'v2/cartdiscounts/getMatchingDiscountForCart/:cartId'}));
              }
        }
    },
    providesTags: ['getCartDiscounts']
    }),
    getDiscountByDiscountId: builder.query({
      query: ({discountId, locale}) => ({
        url: `v2/cartdiscounts/getCartDiscountById/${discountId}`,
        params: { locale: locale },
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

         // Set global discount description if available
          if (data?.description) {
            dispatch(setGlobalDiscounDescription(data.description));
          }
        } catch (error: any) {
          console.log("Error: While fetching discount",error);
          dispatch(setGlobalDiscounDescription(''));
          dispatch(onErrorHandler({operation: 'fetching discount info by discountId', err: JSON.stringify(error), errMsg: 'Error: While fetching discount', api:'v2/cartdiscounts/:discountId'}));
        }
      },
      providesTags: ['getDiscountByDiscountId']
    }),
  }),
});

export const {
  useGetCartDiscountsQuery,
  useGetDiscountByDiscountIdQuery,
} = discountCodeApi;
